module.exports = __webpack_public_path__ + "static/img/cif-md.deed40b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-md.svg
// module id = 5Ghh
// module chunks = 2